import { render, staticRenderFns } from "./footer-creation-buttons.vue?vue&type=template&id=4996be7a&scoped=true"
import script from "./footer-creation-buttons.vue?vue&type=script&lang=js"
export * from "./footer-creation-buttons.vue?vue&type=script&lang=js"
import style0 from "./footer-creation-buttons.vue?vue&type=style&index=0&id=4996be7a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4996be7a",
  null
  
)

export default component.exports